export default __webpack_public_path__ + "static/media/ico-papel.47f50711.svg";